import {management} from '../../../index.js' //api
import {Et0Repository} from '../../infra/knex/repositories/et0'

import {GetEtoByIntervalUseCase} from './getEt0ByInterval'

export const getEt0ByIntervalUseCase=new GetEtoByIntervalUseCase(new Et0Repository(management))
